<template>
    <div>
        <single-chart v-if="mode" @switchMode="switchMode"></single-chart>
        <four-charts v-if="!mode" @switchMode="switchMode"></four-charts>
    </div>
</template>
<script>
import SingleProfitChart from './sig-profit-chart-strategy';
import FourProfitCharts from './fourProfitGrid';
export default {
    data() {
        return {
            mode:true
        }
    },
    components: {
        'single-chart':SingleProfitChart ,
        'four-charts':FourProfitCharts
    },
    methods: {
        switchMode() {
            this.mode = !this.mode;
        }
    },
}
</script>

<style lang="less" scoped>

</style>
